module.exports = __webpack_public_path__ + "img/Serum.527a5c75.svg";